

<template>
  <div class="email__email-sidebar h-full">
    <!-- <div class="m-6 clearfix">
      <vs-button
        class="bg-primary-gradient w-full"
        icon-pack="feather"
        icon="icon-edit"
        @click="activePrompt = true"
        >Compose</vs-button
      >
    </div> -->

    <!-- compose email -->
    <vs-prompt
      class="email-compose"
      title="New Message"
      accept-text="Send"
      @cancel="clearFields"
      @accept="sendMail"
      @close="clearFields"
      :is-valid="validateForm"
      :active.sync="activePrompt"
    >
      <component :is="scrollbarTag" class="scroll-area p-4" :settings="settings" :key="$vs.rtl">
        <form @submit.prevent>
          <vs-input
            v-validate="'required|email'"
            name="mailTo"
            label-placeholder="To"
            v-model="mailTo"
            class="w-full mb-6"
            :danger="!validateForm && mailTo != ''"
            val-icon-danger="clear"
            :success="validateForm"
            val-icon-success="done"
            :color="validateForm ? 'success' : 'danger'"
          />
          <vs-input
            name="mailSubject"
            label-placeholder="Subject"
            v-model="mailSubject"
            class="w-full mb-6"
          />
          <vs-input name="mailCC" label-placeholder="CC" v-model="mailCC" class="w-full mb-6" />
          <vs-input name="mailBCC" label-placeholder="BCC" v-model="mailBCC" class="w-full mb-6" />
          <quill-editor v-model="mailMessage" :options="editorOption" />
          <vs-upload
            multiple
            text="Attachments"
            :show-upload-button="false"
            class="compose-mail-attachment"
          />
        </form>
      </component>
    </vs-prompt>

    <component :is="scrollbarTag" class="email-filter-scroll-area" :settings="settings" :key="$vs.rtl">
      <div class="px-6 pb-2 mt-6 flex flex-col">
        <vs-row vs-justify="space-between" class="mb-4">
          <h5>Cases</h5>
          <div
            class="flex justify-center items-center mr-2 cursor-pointer"
            @click="$emit('update:isMuted', !isMuted)"
          >
            <feather-icon :icon="isMuted ? 'BellOffIcon' : 'BellIcon'" svgClasses="w-5 h-5" />
          </div>
        </vs-row>

        <div class="flex w-full relative">
          <vs-button
            class="pl-2 mb-2 justify-start flex-grow"
            :class="{ 'pl-6': selectedCaseType == 0 }"
            icon="icon-inbox"
            icon-pack="feather"
            :type="selectedCaseType == 0 ? 'filled' : 'flat'"
            @click="$emit('update:selectedCaseType', 0)"
          >
            All
          </vs-button>
          <vs-chip class="absolute" color="grey" style="top: 6px; right: 6px">{{
            filteredConversations.length
          }}</vs-chip>
        </div>

        <div class="flex w-full relative">
          <vs-button
            class="pl-2 mb-2 justify-start flex-grow"
            :class="{ 'pl-6': selectedCaseType == 1 }"
            icon="icon-mail"
            icon-pack="feather"
            :type="selectedCaseType == 1 ? 'filled' : 'flat'"
            @click="$emit('update:selectedCaseType', 1)"
          >
            Open
          </vs-button>
          <vs-chip class="absolute" color="grey" style="top: 6px; right: 6px">{{
            filteredConversations.filter(e => e.isOpen).length
          }}</vs-chip>
        </div>

        <div class="flex w-full relative">
          <vs-button
            class="pl-2 mb-2 justify-start flex-grow"
            :class="{ 'pl-6': selectedCaseType == 2 }"
            icon="icon-star"
            icon-pack="feather"
            :type="selectedCaseType == 2 ? 'filled' : 'flat'"
            @click="$emit('update:selectedCaseType', 2)"
          >
            Important
          </vs-button>
          <vs-chip class="absolute" color="grey" style="top: 6px; right: 6px">{{
            filteredConversations.filter(e => e.topics.some(topic => topic.topic == "Important")).length
          }}</vs-chip>
        </div>

        <div class="flex w-full relative">
          <vs-button
            class="pl-2 mb-2 justify-start flex-grow"
            :class="{ 'pl-6': selectedCaseType == 3 }"
            icon="icon-check-square"
            icon-pack="feather"
            :type="selectedCaseType == 3 ? 'filled' : 'flat'"
            @click="$emit('update:selectedCaseType', 3)"
          >
            Closed
          </vs-button>
          <vs-chip class="absolute" color="grey" style="top: 6px; right: 6px">{{
            filteredConversations.filter(e => !e.isOpen).length
          }}</vs-chip>
        </div>
      </div>
      <vs-divider></vs-divider>
      <div class="flex filter-wrapper pb-4">
        <div class="pt-4 px-6">
          <h5 class="mb-4">Filters</h5>
          <vs-row class="items-center py-1">
            <venue-selector
              :value="filterVenue"
              @input="e => $emit('update:filterVenue', e)"
              :multiple="false"
              placeholder="Select venue"
            />
          </vs-row>
          <vs-row class="items-center py-1">
            <vs-select :value="filterAssigned" @input="e => $emit('update:filterAssigned', e)" class="w-full">
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in filterAssignedOptions"
              />
            </vs-select>
          </vs-row>
        </div>
      </div>

      <vs-divider></vs-divider>

      <div class="email__labels px-6 py-4">
        <h5 class="mb-4">Topics</h5>
        <div class="email__lables-list">
          <vs-row v-for="topic in pickableTopics" :key="topic.topic">
            <vs-chip
              :color="selectedTopics.includes(topic.topic) ? topic.color : 'grey'"
              class="mb-2 cursor-pointer"
              type="border"
              @click.native="selectTopic(topic)"
              >{{ topic.topic }}</vs-chip
            >
          </vs-row>
        </div>
      </div>
    </component>
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import VenueSelector from "@/components/VenueSelector.vue";

export default {
  props: {
    conversations: {
      type: Array,
      required: true,
    },
    filteredConversations: {
      type: Array,
      required: true,
    },
    selectedCaseType: {
      type: Number,
      required: true,
    },
    selectedTopics: {
      type: Array,
      required: true,
    },
    filterVenue: {
      type: String | null,
      required: true,
    },
    filterAssigned: {
      type: Number,
      required: true,
    },
    filterStatus: {
      type: Number,
      required: true,
    },
    isMuted: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      activePrompt: false,
      mailTo: "",
      mailSubject: "",
      mailCC: "",
      mailBCC: "",
      mailMessage: "",
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike", "link", "blockquote", "code-block"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ font: [] }],
          ],
        },
        placeholder: "Message",
      },
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3,
      },
      pickableTopics: [
        // {
        //   color: "#ffb997",
        //   topic: "Important",
        // },
        {
          color: "#f67e7d",
          topic: "Booking",
        },
        {
          color: "#843b62",
          topic: "Nightpay",
        },
        {
          color: "#0b032d",
          topic: "Feedback",
        },
        {
          color: "#44411a",
          topic: "Unrelated",
        },
      ],
      filterAssignedOptions: [
        { text: "Any assignee status", value: 0 },
        { text: "Unassigned", value: 1 },
        { text: "Assigned", value: 2 },
        { text: "Assigned to me", value: 3 },
      ],
    };
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.mailTo !== "";
    },
    baseUrl() {
      const path = this.$route.path;
      return path.slice(0, path.lastIndexOf("/"));
    },
    emailMeta() {
      return this.$store.state.email.meta;
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
  methods: {
    selectTopic(topic) {
      if (this.selectedTopics.some(e => e == topic.topic)) {
        this.$emit(
          "update:selectedTopics",
          this.selectedTopics.filter(e => e != topic.topic),
        );
      } else {
        this.$emit("update:selectedTopics", [...this.selectedTopics, topic.topic]);
      }
    },
    clearFields() {
      this.$nextTick(() => {
        this.mailTo = "";
        this.mailSubject = "";
        this.mailCC = "";
        this.mailBCC = "";
        this.mailMessage = "";
      });
    },
    sendMail() {
      this.clearFields();
    },
  },
  components: {
    quillEditor,
    VuePerfectScrollbar,
    VenueSelector,
  },
};
</script>

